module.exports = __webpack_public_path__ + "img/9-4-2022_raices_thumb.090cf7f7.jpeg";